import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AplicativoComponent } from './page/aplicativo/aplicativo.component';
import { CursoViewComponent } from './page/cursos/curso-view/curso-view.component';
import { CursosComponent } from './page/cursos/cursos.component';
import { QuemSomosComponent } from './page/quem-somos/quem-somos.component';

const routes: Routes = [
  { path: 'quem-somos', component: QuemSomosComponent },
  {
    path: 'aplicativo-para-vidracarias-e-serralherias',
    component: AplicativoComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('./page/pagina-inicio/pagina-inicio.module').then(
        m => m.PaginaInicioModule
      ),
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('./page/blog/blog.module').then(m => m.BlogModule),
  },
  { path: 'home', redirectTo: '' },
  { path: 'cursos', component: CursosComponent },
  { path: 'curso-view', component: CursoViewComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
